export default "__VITE_ASSET__C$nRJ_1c__"